import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  locations: [],
  totalLocationsPages: 0,
  totalLocationsItems: 0
}

const getters = {
  locationsList: state => state.locations,
  totalLocationsPages: state => state.totalLocationsPages,
  totalLocationsItems: state => state.totalLocationsItems
}

const actions = {
  async getLocationsList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.agenda.getLocationsList(payload))
      commit(types.SET_LOCATIONS_LIST, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Locations wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addLocationList ({commit}, newLocation) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.agenda.addLocationList(), { ...newLocation })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Locations was added successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Locations were not added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeLocation ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.agenda.removeLocation(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Locations was removed successfully')
    } catch (err) {
      if (err.response.data.Code === 'fm.cms-0035') {
        commit(types.CREATE_ERROR_MESSAGE, 'Error. There are sessions, connected to this location')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Locations were not removed')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_LOCATIONS_LIST] (state, { locations, totalPages, totalItems }) {
    state.locations = [...locations]
    state.totalLocationsPages = totalPages
    state.totalLocationsItems = totalItems
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/locations.js